import React from 'react';
import { setCurrentView } from 'core/utils';
import { BulkPrintHistoryViewStore } from 'modules/order/stores';
import { BulkPrintHistoryTemplate } from 'themes/modules/order/pages';

@setCurrentView((rootStore, componentProps) => new BulkPrintHistoryViewStore(rootStore, componentProps), 'bulkPrintHistoryViewStore')
class BulkPrintHistory extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<BulkPrintHistoryTemplate
				{...this.props} viewStore={this.props.bulkPrintHistoryViewStore}
			/>
		);
	}
}

export default BulkPrintHistory;



// WEBPACK FOOTER //
// ./src/modules/order/pages/BulkPrintHistory.jsx